import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { createQboidConfigTable, updateQboidConfigTable, deleteQboidConfigTable } from '../graphql/mutations';
import { getQboidConfigTable } from '../graphql/queries';
import { generateClient } from 'aws-amplify/api';

const client = generateClient();

const Qboid = () => {
  const navigate = useNavigate();
  let id = useParams()?.id;
  const [status, setStatus] = useState({ message: "" });
  const [qboidInfo, setQboidInfo] = useState({
    originalSerialNumber: "",
    SerialNumber: "",
    CustomerName: "",
    InsertTime: "",
    LengthField: "custitem_rfs_packing_length",
    WidthField: "custitem_rfs_packing_width",
    HeightField: "custitem_rfs_packing_height",
    WeightField: "weight",
    ImageField: "",
    AltDimType: "",
    AltLengthField: "",
    AltWidthField: "",
    AltHeightField: "",
    AltWeightField: "",
    AltImageField: "",
    LengthUnit: "CM",
    WeightUnit: "GR",
    AlwaysRoundUpWeight: false,
    AlwaysRoundUpLength: false,
    WeightRoundingDigits: 0,
    LengthRoundingDigits: 0,
    ConnectionName: "",
    ExternalId: "",
    AttributeMappings: "{}"
  })

  useEffect(() => {
    async function fetchData() {
      if (id && id.length > 0) {
        const qboidDetails = {
          id: id,
        };
        const result = await client.graphql({
          query: getQboidConfigTable,
          variables: qboidDetails
        });
        if (result) {
          const dbData = {
            originalSerialNumber: result.data.getQboidConfigTable.SerialNumber,
            SerialNumber: result.data.getQboidConfigTable.SerialNumber,
            CustomerName: result.data.getQboidConfigTable.CustomerName,
            InsertTime: result.data.getQboidConfigTable.InsertTime,
            LengthField: result.data.getQboidConfigTable.LengthField,
            WidthField: result.data.getQboidConfigTable.WidthField,
            HeightField: result.data.getQboidConfigTable.HeightField,
            WeightField: result.data.getQboidConfigTable.WeightField,
            ImageField: result.data.getQboidConfigTable.ImageField,
            AltDimType: result.data.getQboidConfigTable.AltDimType,
            AltLengthField: result.data.getQboidConfigTable.AltLengthField,
            AltWidthField: result.data.getQboidConfigTable.AltWidthField,
            AltHeightField: result.data.getQboidConfigTable.AltHeightField,
            AltWeightField: result.data.getQboidConfigTable.AltWeightField,
            AltImageField: result.data.getQboidConfigTable.AltImageField,
            LengthUnit: result.data.getQboidConfigTable.LengthUnit,
            WeightUnit: result.data.getQboidConfigTable.WeightUnit,
            AlwaysRoundUpWeight: result.data.getQboidConfigTable.AlwaysRoundUpWeight,
            AlwaysRoundUpLength: result.data.getQboidConfigTable.AlwaysRoundUpLength,
            WeightRoundingDigits: result.data.getQboidConfigTable.WeightRoundingDigits,
            LengthRoundingDigits: result.data.getQboidConfigTable.LengthRoundingDigits,
            ConnectionName: result.data.getQboidConfigTable.ConnectionName,
            ExternalId: result.data.getQboidConfigTable.ExternalId,
            AttributeMappings: result.data.getQboidConfigTable.AttributeMappings
          };
          setQboidInfo(dbData);
        }
      }
    }
    fetchData();
  }, [id]);

  const onChange = (e) => {
    setQboidInfo({ ...qboidInfo, [e.target.id]: e.target.value });
  };

  const onBlur = (e) => {
    setQboidInfo({ ...qboidInfo, [e.target.id]: e.target.value.trim() });
  };

  const onCheckedChange = (e) => {
    setQboidInfo({ ...qboidInfo, [e.target.id]: e.target.checked });
  };

  async function updateQboid() {
    if (qboidInfo.originalSerialNumber === qboidInfo.SerialNumber && id && id.length > 0) {
      //update

      var qboidData = {
        id: id,
        SerialNumber: qboidInfo.SerialNumber,
        CustomerName: qboidInfo.CustomerName,
        LengthField: qboidInfo.LengthField,
        WidthField: qboidInfo.WidthField,
        HeightField: qboidInfo.HeightField,
        WeightField: qboidInfo.WeightField,
        ImageField: qboidInfo.ImageField,
        AltDimType: qboidInfo.AltDimType,
        AltLengthField: qboidInfo.AltLengthField,
        AltWidthField: qboidInfo.AltWidthField,
        AltHeightField: qboidInfo.AltHeightField,
        AltWeightField: qboidInfo.AltWeightField,
        AltImageField: qboidInfo.AltImageField,
        LengthUnit: qboidInfo.LengthUnit,
        WeightUnit: qboidInfo.WeightUnit,
        AlwaysRoundUpWeight: qboidInfo.AlwaysRoundUpWeight,
        AlwaysRoundUpLength: qboidInfo.AlwaysRoundUpLength,
        WeightRoundingDigits: parseInt(qboidInfo.WeightRoundingDigits),
        LengthRoundingDigits: parseInt(qboidInfo.LengthRoundingDigits),
        InsertTime: new Date().toISOString(),
        ConnectionName: qboidInfo.ConnectionName,
        ExternalId: qboidInfo.ExternalId,
        AttributeMappings: qboidInfo.AttributeMappings
      };
      const qboidDetails = {
        SerialNumber: { eq: qboidInfo.SerialNumber }
      };
      var test = await client.graphql({ query: updateQboidConfigTable, variables: { input: qboidData, condition: qboidDetails } });

      setStatus({ message: 'Update Successful' });
    }
    else {
      var qboidData = {
        SerialNumber: qboidInfo.SerialNumber,
        CustomerName: qboidInfo.CustomerName,
        LengthField: qboidInfo.LengthField,
        WidthField: qboidInfo.WidthField,
        HeightField: qboidInfo.HeightField,
        WeightField: qboidInfo.WeightField,
        ImageField: qboidInfo.ImageField,
        AltDimType: qboidInfo.AltDimType,
        AltLengthField: qboidInfo.AltLengthField,
        AltWidthField: qboidInfo.AltWidthField,
        AltHeightField: qboidInfo.AltHeightField,
        AltWeightField: qboidInfo.AltWeightField,
        AltImageField: qboidInfo.AltImageField,
        LengthUnit: qboidInfo.LengthUnit,
        WeightUnit: qboidInfo.WeightUnit,
        AlwaysRoundUpWeight: qboidInfo.AlwaysRoundUpWeight,
        AlwaysRoundUpLength: qboidInfo.AlwaysRoundUpLength,
        WeightRoundingDigits: parseInt(qboidInfo.WeightRoundingDigits),
        LengthRoundingDigits: parseInt(qboidInfo.LengthRoundingDigits),
        InsertTime: new Date().toISOString(),
        ConnectionName: qboidInfo.ConnectionName,
        ExternalId: qboidInfo.ExternalId,
        AttributeMappings: qboidInfo.AttributeMappings
      };
      await client.graphql({ query: createQboidConfigTable, variables: { input: qboidData } });
      setStatus({ message: 'Insert Successful' });
      navigate("/qboids/")
    }

    console.log("Qboid saved");
  }

  async function deleteQboid() {
    if (id && id.length > 0) {
      const qboidDetails = {
        id: id
      };
      const deletedQboid = await client.graphql({ query: deleteQboidConfigTable, variables: { input: qboidDetails } });
    }
  }

  const onDelete = (e) => {
    e.preventDefault();
    deleteQboid();
    setStatus({ message: 'Delete Successful' });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    console.log(qboidInfo.AlwaysRoundUpWeight);
    updateQboid();
    console.log(qboidInfo);
  };

  return (
    <form className="ui form" onSubmit={onSubmit}>
      <div className="equal width fields">
        <div className="field">
          <label htmlFor="SerialNumber">Serial Number</label>
          <input type="text" className="ui fluid input" placeholder="Serial Number" id="SerialNumber" value={qboidInfo.SerialNumber} onChange={onChange} onBlur={onBlur} required={true} />
        </div>
        <div className="field">
          <label htmlFor="CustomerName">Customer Name</label>
          <input type="text" className="ui fluid input" placeholder="Customer Name" id="CustomerName" value={qboidInfo.CustomerName} onChange={onChange} onBlur={onBlur} required={true} />
        </div>
        <div className="field">
          <label htmlFor="ConnectionName">Connection Name</label>
          <input type="text" className="ui fluid input" placeholder="Connection Name" id="ConnectionName" value={qboidInfo.ConnectionName} onChange={onChange} onBlur={onBlur} required={true} />
        </div>
        <div className="field">
          <label htmlFor="ExternalId">External Id</label>
          <input type="text" className="ui fluid input" placeholder="External Id" id="ExternalId" value={qboidInfo.ExternalId} onChange={onChange} onBlur={onBlur} required={true} />
        </div>
      </div>
      <div className="equal width fields">
        <div className="field">
          <label htmlFor="LengthField">Length Field</label>
          <input type="text" className="ui fluid input" placeholder="Length Field" id="LengthField" value={qboidInfo.LengthField} onChange={onChange} onBlur={onBlur} required={true} />
        </div>
        <div className="field">
          <label htmlFor="WidthField">Width Field</label>
          <input type="text" className="ui fluid input" placeholder="Width Field" id="WidthField" value={qboidInfo.WidthField} onChange={onChange} onBlur={onBlur} required={true} />
        </div>
        <div className="field">
          <label htmlFor="HeightField">Height Field</label>
          <input type="text" className="ui fluid input" placeholder="Height Field" id="HeightField" value={qboidInfo.HeightField} onChange={onChange} onBlur={onBlur} required={true} />
        </div>
        <div className="field">
          <label htmlFor="WeightField">Weight Field</label>
          <input type="text" className="ui fluid input" placeholder="Weight Field" id="WeightField" value={qboidInfo.WeightField} onChange={onChange} onBlur={onBlur} />
        </div>
      </div>
      <div className="equal width fields">
        <div className="field">
          <label htmlFor="ImageField">Image Field</label>
          <input type="text" className="ui fluid input" placeholder="Image Field" id="ImageField" value={qboidInfo.ImageField} onChange={onChange} onBlur={onBlur} />
        </div>
        <div className="field">
          <label htmlFor="AltDimType">Alt Dim Type</label>
          <input type="text" className="ui fluid input" placeholder="Alt Dim Type" id="AltDimType" value={qboidInfo.AltDimType} onChange={onChange} onBlur={onBlur} />
        </div>
        <div className="field">
          <label htmlFor="AltLengthField">Alt Length Field</label>
          <input type="text" className="ui fluid input" placeholder="Alt Length Field" id="AltLengthField" value={qboidInfo.AltLengthField} onChange={onChange} onBlur={onBlur} />
        </div>
        <div className="field">
          <label htmlFor="AltWidthField">Alt Width Field</label>
          <input type="text" className="ui fluid input" placeholder="Alt Width Field" id="AltWidthField" value={qboidInfo.AltWidthField} onChange={onChange} onBlur={onBlur} />
        </div>
      </div>
      <div className="equal width fields">
        <div className="field">
          <label htmlFor="AltHeightField">Alt Height Field</label>
          <input type="text" className="ui fluid input" placeholder="Alt Height Field" id="AltHeightField" value={qboidInfo.AltHeightField} onChange={onChange} onBlur={onBlur} />
        </div>
        <div className="field">
          <label htmlFor="AltWeightField">Alt Weight Field</label>
          <input type="text" className="ui fluid input" placeholder="Alt Weight Field" id="AltWeightField" value={qboidInfo.AltWeightField} onChange={onChange} onBlur={onBlur} />
        </div>
        <div className="field">
          <label htmlFor="LengthUnit">Length Unit</label>
          <select id="LengthUnit" onChange={onChange} onBlur={onBlur} value={qboidInfo.LengthUnit}>
            <option value="IN">Inches</option>
            <option value="FT">Feet</option>
            <option value="YD">Yards</option>
            <option value="M">Meters</option>
            <option value="CM">Centimeters</option>
            <option value="MM">Millimeters</option>
          </select>
        </div>
        <div className="field">
          <label htmlFor="WeightUnit">Weight Unit</label>
          <select id="WeightUnit" onChange={onChange} onBlur={onBlur} value={qboidInfo.WeightUnit}>
            <option value="GR">Grams</option>
            <option value="KG">Kilograms</option>
            <option value="MG">Milligrams</option>
            <option value="OZ">Ounces</option>
            <option value="LB">Pounds</option>
          </select>
        </div>
      </div>
      <div className="equal width fields">
        <div className="field">
          <label htmlFor="AlwaysRoundUpWeight">Always Round Up Weight</label>
          <input type="checkbox" className="ui fluid input" placeholder="Always Round Up Weight" id="AlwaysRoundUpWeight" checked={qboidInfo.AlwaysRoundUpWeight} onChange={onCheckedChange} />
        </div>
        <div className="field">
          <label htmlFor="AlwaysRoundUpLength">Always Round Up Dimensions</label>
          <input type="checkbox" className="ui fluid input" placeholder="Always Round Up Dimensions" id="AlwaysRoundUpLength" checked={qboidInfo.AlwaysRoundUpLength} onChange={onCheckedChange} />
        </div>
        <div className="field">
          <label htmlFor="WeightRoundingDigits">Weight Rounding Digits</label>
          <input type="number" className="ui fluid input" placeholder="Weight Rounding Digits" id="WeightRoundingDigits" value={qboidInfo.WeightRoundingDigits} onChange={onChange} onBlur={onBlur} required={true} />
        </div>
        <div className="field">
          <label htmlFor="LengthRoundingDigits">Length Rounding Digits</label>
          <input type="number" className="ui fluid input" placeholder="Length Rounding Digits" id="LengthRoundingDigits" value={qboidInfo.LengthRoundingDigits} onChange={onChange} onBlur={onBlur} required={true} />
        </div>
      </div>
      <div className="equal width fields">
        <div className="field">
          <label htmlFor="AttributeMappings">Attribute Mappings</label>
          <input type="text" className="ui fluid input" placeholder="Attribute Mappings" id="AttributeMappings" value={qboidInfo.AttributeMappings} onChange={onChange} onBlur={onBlur} />
        </div>
      </div>
      <div className="equal width fields">
        <div className="field">
          <button className="ui button" type="submit" >Submit</button>
        </div>
      </div>
      <div>{status.message}</div>
    </form>
  )
}

export default Qboid;